import { DsButtonBase } from "../DsButtonBase/DsButtonBase"
import { DsButtonsType } from "../DsButtonsTypes"

export type DsButtonSecondaryProps = DsButtonsType

export function DsButtonSecondary(props: DsButtonsType) {
  return <DsButtonBase {...props} variant="outline" />
}
